import { COMPANIES_SEARCH_MAX_PAGE_SIZE } from 'models'
import { useGetCompanies, UseGetCompaniesOptions } from './useGetCompanies'

const useGetOrphanCompanies = (searchTerm?: string, options?: UseGetCompaniesOptions) => {
  return useGetCompanies(
    {
      hasParent: false,
      hasChildren: false,
      paging: { page: 1, pageSize: COMPANIES_SEARCH_MAX_PAGE_SIZE },
      sort: [{ field: 'name', direction: 'asc' }],
      ...(searchTerm ? { name: { contains: searchTerm } } : {}),
    },
    options,
  )
}

export { useGetOrphanCompanies }
